import React from 'react';
import { PreviousManualsType } from '../../../util/types';
import PreviousPage from '../../../components/PreviousPage/PreviousPage';
import NotFoundPage from '../../../components/NotFoundPage/NotFoundPage';
import { product as productLabels } from '../../../mockdata';
import fetchProductData from '../../../axios/fetchProductData';
import { useRouter } from 'next/router';

interface SlugPageInterface {
  data: PreviousManualsType;
  locale?: string;
  slug?: string;
  localeCountry?: string;
}

export default function SlugPage({ data, locale, slug, localeCountry }: SlugPageInterface) {
  const router = useRouter();
  return !data ? (
    <NotFoundPage locale={locale || 'en'} />
  ) : (
    <PreviousPage
      {...data}
      locale={locale || 'en'}
      labels={productLabels}
      localeCountry={localeCountry}
      backLink={{
        href: router.asPath.replace(`/${slug}`, ''),
        children: productLabels.back_to_product,
      }}
    />
  );
}

export const getServerSideProps = fetchProductData({});
